import React from 'react';

export type Props = {
  className?: string;
  color?: string;
  height?: number;
  onClick?(): void;
  width?: number;
};

export const Hamburger = React.memo((props: Props) => {
  return (
    <svg
      width={props.width || 24}
      height={props.height || 24}
      className={props.className}
      onClick={props.onClick}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path d='M2 6H16' stroke={props.color || '#0F0A1B'} strokeWidth='3' strokeLinecap='round' />
      <path d='M2 12H20' stroke={props.color || '#0F0A1B'} strokeWidth='3' strokeLinecap='round' />
      <path d='M2 18H16' stroke={props.color || '#0F0A1B'} strokeWidth='3' strokeLinecap='round' />
    </svg>
  );
});
